var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isOpen
    ? _c(
        "PopupUI",
        {
          staticClass: "phone-verification-call",
          attrs: { small: true },
          on: { "on-close": _vm.hide }
        },
        [
          _c("template", { slot: "header" }, [
            _c(
              "h3",
              {
                staticClass: "subtitle-h3 txt-blue-common txt-center no-margin"
              },
              [_vm._v("\n      Подтвердите номер телефона\n    ")]
            )
          ]),
          _vm._v(" "),
          [
            _c(
              "div",
              { staticClass: "txt-center txt-secondary-on-wite txt-s" },
              [
                _vm._v("\n      На ваш номер "),
                _c("nobr", [_vm._v(_vm._s(_vm.phoneFormatted))]),
                _vm._v(
                  " позвонит\n      наш робот и продиктует код.\n      Введите его в поле ниже\n    "
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("CodeEntryFormUI", {
              staticClass: "phone-verification-call__form",
              attrs: {
                "init-send-code": true,
                "function-for-resend-code": _vm.functionForResendCode,
                "show-loader": _vm.showLoader,
                "server-errors": _vm.serverErrors,
                "btn-title": "Позвонить ещё раз"
              },
              on: {
                "send-code": _vm.updateCode,
                "send-new-code": function($event) {
                  _vm.serverErrors = null
                }
              }
            })
          ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }